import { url } from '../../axios/api_urls/formulation'
const api = require('../../axios/request')
const UPDATE_STATE = 'UPDATE_STATE'
const UPDATE_STATE_OBJECT = 'UPDATE_STATE_OBJECT'
const UPDATE_OPTIONS = 'UPDATE_OPTIONS'
const UPDATE_ALL_INCI = 'UPDATE_ALL_INCI'
const state = {
  options: {
    approver: [],
    category: [],
    form: [],
    SPF: [],
    PA: [],
    aspects: [],
    claim: [],
    country: [],
    priceRange: [],
    applicationArea: [],
    specificGroup: [],
    type: [],
    year: []
  },
  pcFilter: {},
  pcPage:{
    total: 0,
    size: 10,
    current: 1
  },
  backFilter: {},
  backPage:{
    total: 0,
    size: 10,
    current: 1
  },
  allInci: []
}
const getters = {
  options: state => state.options,
  pcFilter: state => state.pcFilter,
  pcPage: state => state.pcPage,
  backFilter: state => state.backFilter,
  backPage: state => state.backPage,
  allInci: state => state.allInci.map(v => {
    return {
      label: v.inciName,
      value: v.id
    }
  })
}
const mutations = {
  [UPDATE_STATE] (context, payload) {
    context[payload.key] = payload.value
  },
  // 修改对象公共方法
  [UPDATE_STATE_OBJECT] (context, payload) {
    context[payload.key] = {...context[payload.key], ...payload.obj}
  },
  [UPDATE_OPTIONS] (context, payload) {
    context.options[payload.key] = payload.value || []
  },
  [UPDATE_ALL_INCI] (context, payload) {
    context.allInci = payload || []
  }
}
const actions = {
  initList ({state, commit}) {
    api._post(url.category).then(res => {commit(UPDATE_OPTIONS, {key: 'category', value: res.data})})
    api._post(url.form).then(res => {commit(UPDATE_OPTIONS, {key: 'form', value: res.data})})
    api._post(url.SPF).then(res => {commit(UPDATE_OPTIONS, {key: 'SPF', value: res.data})})
    api._post(url.PA).then(res => {commit(UPDATE_OPTIONS, {key: 'PA', value: res.data})})
    api._post(url.aspects).then(res => {commit(UPDATE_OPTIONS, {key: 'aspects', value: res.data})})
    api._post(url.country, {keyword: ''}).then(res => {commit(UPDATE_OPTIONS, {key: 'country', value: res.data})})
    api._post(url.claim, {keyword: ''}).then(res => {commit(UPDATE_OPTIONS, {key: 'claim', value: res.data})})
    api._post(url.applicationArea).then(res => {commit(UPDATE_OPTIONS, {key: 'applicationArea', value: res.data})})
    api._post(url.specificGroup).then(res => {commit(UPDATE_OPTIONS, {key: 'specificGroup', value: res.data})})
    api._post(url.GET_DICTIONARY, {parentId: 18}).then(res => {commit(UPDATE_OPTIONS, {key: 'priceRange', value: res.data})})
    api._post(url.GET_DICTIONARY, {parentId: 245}).then(res => {commit(UPDATE_OPTIONS, {key: 'type', value: res.data})})
    // 年
    api._post(url.GET_DICTIONARY, {parentId: 177}).then(res => {commit(UPDATE_OPTIONS, {key: 'year', value: res.data.reverse()})})
  },
  getSubCategory(context, payload){
    return api._post(url.subCategory, {pid2: payload})
  },
  getApplicationArea(context, payload){
    return api._post(url.subCategories, {pid2Str: payload})
  },
  getTagList(context, payload){
    try {
      return api._post(url.tagList, {keyword: payload})
    } catch(e) {}
  },
  getInciList(context, payload){
    return api._post(url.findInci, {inciParam: payload})
  },
  getApproverList(context, payload = ''){
    return api._post(url.approverList, {keyword: payload})
  },
  getTradeList(context, payload){
    return api._post(url.tradeNameList, {keyword: payload})
  },
  getINCIList(context, payload){
    return api._post(url.INCIList, {keyword: payload})
  },
  getSearchUserList(context, payload = ''){
    return api._post(url.searchUserList, {keyword: payload})
  },
  getAllList(context, payload){
    return api._post(url.allList, payload)
  },
  getMyList(context, payload){
    return api._post(url.myList, payload)
  },
  addFormulation(context, payload){
    return api._post(url.add, payload)
  },
  updateFormulation(context, payload){
    return api._post(url.update, payload)
  },
  editUploadFormulation(context, payload){
    return api._post(url.editUploadFormulation, payload)
  },
  approval(context, payload){
    return api._post(url.judge, payload)
  },
  withdraw(context, payload){
    return api._post(url.withdraw, payload)
  },
  getMyDetail(context, payload){
    return api._post(url.myDetail, {id: payload})
  },
  getAddDetail(context, payload){
    return api._post(url.addDetail, payload)
  },
  getAllDetail(context, payload){
    return api._post(url.allDetail, {id: payload})
  },
  getPendingCount(context, payload){
    return api._post(url.pending, payload)
  },
  // Similar formulation with same claims
  getRecommendProduct(context, obj){
    return api._post(url.recommendProduct, obj)
  },
  getRelationList(context, payload){
    return api._post(url.relationList, payload)
  },
  getRelationDetail(context, payload){
    return api._post(url.relationDetail, {id: payload})
  },
  updateRelation(context, payload){
    return api._post(url.updateRelation, payload)
  },
  getFormulationList(context, payload){
    return api._post(url.formulationList, payload)
  },
  getFormulationDetail(context, payload){
    return api._post(url.formulationDetail, {id: payload})
  },
  getSimilarFormulation(context, obj){
    return api._post(url.similarFormulation, obj)
  },
  getRecommendFormulation(context, obj){
    return api._post(url.similarFormulation, obj)
  },
  getKeyBasfProduct(context, obj){
    return api._post(url.keyBasfProduct, obj)
  },
  getPdfParsing(context, obj){
    return api._post(url.pdfParsing, obj)
  },
  updateStatus(context, obj){
    return api._post(url.updateStatus, obj)
  },
  relateConceptApi(context, params){
    return api._post(url.relateConcept, params)
  },
  similarFormulationMap(context, params) {
    return api._post(url.similarFormulationMap, params)
  },
  async getAllInciFilterApi({ commit }, params) {
    try {
      const { data: res } = await api._post(url.getAllInciFilter, params)
      commit(UPDATE_ALL_INCI, res || [])
    } catch (e) {}
  },
  getUploadFormulationCount(context, params) {
    return api._post(url.getUploadFormulationCount, params)
  },
  getLastUpdateTimeApi(context, params) {
    try {
      return api._post(url.getLastUpdateTime, params)
    } catch (e) {}
  },
  deleteApi(context, params) {
    try {
      return api._post(url.delete, params)
    } catch (e) {}
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/formulation.js